import { createApp } from 'vue';
import App from './App.vue';
import './assets/main.scss'
import Vueform from '@vueform/vueform'
import {Config} from 'vueform'

createApp(App)
    .use(Vueform, Config)
    .mount('#lvm-simple-vacancy')